<template>
  <TransitionRoot appear :show="store.verifyLicenseKeyModal" as="template">
    <Dialog as="div" @close="closeModal" class="relative z-50">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/25" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4 text-center">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel class="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all relative">
              <div v-if="isLoading" class="absolute inset-0 bg-white/80 flex items-center justify-center z-10">
                <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
              </div>
              <DialogTitle as="h3" class="text-lg font-medium leading-6 text-gray-900">
                Enter license key
              </DialogTitle>

              <div class="mt-4">
                <form @submit.prevent="verifyLicenseKey">
                  <input
                    type="password"
                    v-model="licenseKey"
                    placeholder="Paste license key here"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    autocomplete="off"
                  />
                </form>
              </div>

              <div class="mt-6 flex justify-end space-x-3">
                <button
                  type="button"
                  :disabled="isLoading"
                  class="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  @click="verifyLicenseKey"
                >
                  Verify
                </button>
                <button
                  type="button"
                  :disabled="isLoading"
                  class="inline-flex justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  @click="closeModal"
                >
                  Cancel
                </button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { store, loadUserSettings, showDialog } from '../store'
import { nextTick } from 'vue'
import apiClient from '../utils/axios'
import router from '../router'
import CrispService from '../services/crisp'
import * as Sentry from '@sentry/vue';

export default {
  name: 'LicenseKeyModal',
  components: {
    Dialog,
    DialogPanel,
    DialogTitle,
    TransitionChild,
    TransitionRoot
  },
  data() {
    return {
      licenseKey: '',
      store,
      isLoading: false
    }
  },
  methods: {
    closeModal() {
      store.verifyLicenseKeyModal = false
      this.licenseKey = ''
      this.isLoading = false
    },
    async verifyLicenseKey() {
      this.isLoading = true
      try {
        const response = await apiClient.post('https://api.nevua.markets/auth/verify-license-key', {
          license_key: this.licenseKey
        })
        
        if (response.status === 200) {
          localStorage.setItem('jwtToken', response.data.token);
          await loadUserSettings(response.data.token);
          CrispService.client.user.setEmail(store.email);
          store.isLoggedIn = true;

          this.closeModal()
          nextTick(() => {
            console.log('License key verified')
            store.showWelcomeModal = true
          })
        }
      } catch (error) {
        Sentry.setExtra('method', 'verifyLicenseKey');
        Sentry.captureException(error);
        showDialog({
          message: 'Invalid license key',
          type: 'error',
          timeout: 3000
        })
        this.closeModal()
      } finally {
        this.isLoading = false
        router.push('/')
      }
    }
  }
}
</script> 